export default __webpack_public_path__ + "static/media/torus.8cba2e0f.svg";